<template>
  <div class="video-upload-wrapper" v-show="uploadList.length > 0">
    <input type="file" accept="video/*" style="display: none" ref="input" multiple="multiple" @change="fileChange"/>
    <div class="video-item">
      <div class="video-bar" v-for="(item, index) in uploadList" :key="item.path">
        <VideoBtn :disabled="true"></VideoBtn>
        <span class="name">{{ item.fileName }}</span>
        <el-progress class="progress" :text-inside="true" :stroke-width="20" :format="format"
                     :percentage="item.progress" :color="progressColor"></el-progress>
        <el-tag :type="item.fail ? 'danger' : (item.progress >= 100 ? 'success' : 'info')" size="mini">
          {{ item.fail ? '上传失败' : (item.progress >= 100 ? '上传成功' : '正在上传')}}
        </el-tag>
        <i class="del el-icon-circle-close" title="移除" @click="remove(index)"></i>
      </div>
    </div>
  </div>
</template>

<script>
    import VideoBtn from "../iconBtn/VideoBtn";
    import setting from "../../config/setting";
    import {uuid} from "../../js/utils/uuid";

    export default {
        name: "VideoUpload",
        components: {VideoBtn},
        props: {
            //上传数量
            limit: {
                type: Number,
                default: 9
            },
            //oss上传参数
            uploadOption: {
                type: Object,
                required: false
            },
        },
        created() {
            this.limitCopy = this.limit > 0 && this.limit <= 9 ? this.limit : 9;
        },
        data() {
            return {
                limitCopy: 0,
                uploadList: [],
                progressColor: [
                    {color: '#909399', percentage: 30},
                    {color: '#e6a23c', percentage: 70},
                    {color: '#67c23a', percentage: 100}
                ],

            }
        },
        methods: {
            checkUpload(fileArr) {
                if ((this.uploadList.length + fileArr.length) > this.limitCopy) {
                    return "最多上传" + this.limitCopy + "个视频";
                }
                for (let i = 0; i < fileArr.length; i++) {
                    if (!/^video\/(avi|wmv|mpg|mpeg|mov|3gp|rm|ram|swf|flv|mp4)/g.test(fileArr[i].type)) {
                        return "请上传常用的视频格式";
                    }
                    if (fileArr[i].size > setting.videoUploadSize) {
                        return "视频不能超过50MB";
                    }
                }
            },
            format(percentage) {
                return percentage + "%";
            },
            addVideo() {
                this.$refs.input.click();
            },
            fileChange(e) {
                let files = e.target.files;
                if (files.length === 0) {
                    return;
                }
                let check = this.checkUpload(files);
                if (check) {
                    e.target.value = "";
                    return this.$im.showMessage(check, {icon: 5})
                }
                for (let i = 0; i < files.length; i++) {
                    this.upload(files[i]);
                }
                e.target.value = "";

            },
            //上传oos
            upload(file) {
                this.beforeUpload();
                let blob = new Blob([file], {type: file.type});
                if (blob.size > setting.videoUploadSize) {
                    return this.$im.showMessage("视频不能超过50MB", {icon: 5});
                }
                let upload = {
                    fileName: file.name,
                    url: URL.createObjectURL(blob),
                    path: setting.ossUploadPre + uuid() + "." + blob.type.split("/")[1],
                    progress: 0,
                    fail: false,
                };
                this.uploadList.push(upload);
                this.$im.ossUpload(upload.path, blob, this.uploadOption, (url) => {
                    this.change();
                }, (progress) => {
                    upload.progress = progress;
                }, (msg) => {
                    upload.fail = true;
                });
            },
            change() {
                this.$emit("change", this.uploadList.filter(item => item.progress >= 100).map(item => item.path));
            },
            remove(index) {
                this.uploadList.splice(index, 1);
                this.change();
            },
            clean() {
                this.uploadList = [];
                this.change();
            },
            beforeUpload() {
                this.$emit("beforeUpload");
            }
        },
    }
</script>

<style scoped>
  .video-upload-wrapper {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    padding: 8px;
    border-radius: 4px;
  }
  .video-item {
  }
  .video-bar {
    display: flex;
    align-items: center;
  }
  .video-bar > :not(:last-child) {
    margin-right: 8px;
  }

  .video-bar .name {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .video-bar > .progress {
    flex-grow: 1;
  }

  .video-bar > .del {
    font-size: 18px;
    color: #7b7b7b;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/view/baseComponent/VideoUpload.vue